import './round-loader.scss';

export enum RoundLoaderType {
    Light = 'light',
    Dark = 'dark',
}

interface IProps {
    type?: RoundLoaderType
}

const RoundLoader: React.FC<IProps> = ({ type = RoundLoaderType.Light }) => {
    return (
        <div className={`round-loader ${type}`}>
            <span></span>
        </div>
    )
}

export default RoundLoader;
